export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9519.5b1d6562.jpg";